package one.healthium.settings.data.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SettingsItemDto(
    @SerialName("title") val title: String,
    @SerialName("url") val url: String,
)
